module.exports = __webpack_public_path__ + "static/img/RGH-Employee-Communicaton2.79703d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/whoweare/RGH-Employee-Communicaton2.jpg
// module id = Ovgm
// module chunks = 1